import { Link } from "react-router-dom";
import { Reveal, Eyebrow } from "@/components/primitives";
import { PROJECTS } from "@/data/projects";

function LoopCard({ p, i }) {
  return (
    <Link
      to={`/projects/${p.slug}`}
      className="group w-[78vw] shrink-0 sm:w-[46vw] lg:w-[28vw] xl:w-[24vw]"
      data-testid={`project-loop-card-${i + 1}`}
    >
      <article>
        <div className="relative overflow-hidden">
          <img
            src={p.img}
            alt={`${p.name} · ${p.type}`}
            loading="lazy"
            className="aspect-[16/11] w-full object-cover transition-transform duration-700 ease-out group-hover:scale-[1.05]"
          />
          <div className="absolute inset-0 bg-ink/0 transition-colors duration-500 group-hover:bg-ink/15" />
          <span className="absolute bottom-4 left-4 bg-navy-deep/80 px-3 py-1.5 text-[10px] font-medium uppercase tracking-[0.25em] text-paper backdrop-blur-sm">
            {p.type}
          </span>
        </div>
        <h3 className="mt-5 font-serif text-2xl text-ink transition-colors duration-300 group-hover:text-maroon">
          {p.name}
        </h3>
        {(p.area || p.location) && (
          <p className="mt-2 text-[11px] font-medium uppercase tracking-[0.15em] text-ink/50">
            {[p.area, p.location].filter(Boolean).join(" · ")}
          </p>
        )}
        {p.scope && (
          <p className="mt-1 text-[11px] font-medium uppercase tracking-[0.15em] text-navy">{p.scope}</p>
        )}
      </article>
    </Link>
  );
}

export default function ProjectsLoop() {
  return (
    <section className="bg-paper pb-24 pt-4 lg:pb-36" data-testid="projects-loop-section">
      <div className="mx-auto max-w-[1440px] px-6 lg:px-12">
        <Reveal>
          <Eyebrow index="03">Selected Work</Eyebrow>
        </Reveal>
        <Reveal delay={0.1}>
          <h2 className="mt-6 font-serif text-4xl text-ink sm:text-5xl">Our Projects</h2>
        </Reveal>
      </div>

      <div className="marquee-hover-pause relative mt-14 overflow-hidden" data-testid="projects-loop-track">
        <div className="pointer-events-none absolute inset-y-0 left-0 z-10 w-16 bg-gradient-to-r from-paper to-transparent" />
        <div className="pointer-events-none absolute inset-y-0 right-0 z-10 w-16 bg-gradient-to-l from-paper to-transparent" />
        <div className="marquee-track animate-marquee" style={{ animationDuration: "85s" }}>
          {[0, 1].map((dup) => (
            <div key={dup} aria-hidden={dup === 1} className="flex shrink-0 gap-10 pr-10">
              {PROJECTS.map((p, i) => (
                <LoopCard key={`${dup}-${p.slug}`} p={p} i={i} />
              ))}
            </div>
          ))}
        </div>
      </div>

      <div className="mt-14 flex justify-center">
        <a
          href="/projects"
          data-testid="explore-projects-button"
          className="group inline-flex items-center gap-3 rounded-full bg-maroon px-10 py-4 text-[12px] font-medium uppercase tracking-[0.2em] text-paper transition-transform duration-300 hover:scale-[1.04]"
        >
          Explore Our Projects
          <span className="inline-block transition-transform duration-300 group-hover:translate-x-1">→</span>
        </a>
      </div>
    </section>
  );
}
